import _styled from '@emotion/styled/base';
import { TYPOGRAPHY_STYLE } from '../typography/index.js';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import SPACER from '../../constants/spacer/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import { applyPrimaryThemeVerticalOffset } from '../../utils/themeStyles/index.js';

var ChipText = _styled("span", {
  target: "e88p7tz1",
  label: "ChipText"
})(_ref => {
  var {
    theme
  } = _ref;
  return TYPOGRAPHY_STYLE.label(theme);
}, " font-weight:", _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.TYPOGRAPHY.fontWeight.bold;
}, ";", _ref3 => {
  var {
    theme
  } = _ref3;
  return applyPrimaryThemeVerticalOffset(theme);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUk2QiIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRZUE9HUkFQSFlfU1RZTEUgfSBmcm9tICcuLi90eXBvZ3JhcGh5JztcbmltcG9ydCB7IFNQQUNFUiB9IGZyb20gJy4uLy4uL2NvbnN0YW50cyc7XG5pbXBvcnQgeyBhcHBseVByaW1hcnlUaGVtZVZlcnRpY2FsT2Zmc2V0IH0gZnJvbSAnLi4vLi4vdXRpbHMvdGhlbWVTdHlsZXMnO1xuY29uc3QgQ2hpcFRleHQgPSBzdHlsZWQuc3BhbiBgXG4gICR7KHsgdGhlbWUgfSkgPT4gVFlQT0dSQVBIWV9TVFlMRS5sYWJlbCh0aGVtZSl9XG4gIGZvbnQtd2VpZ2h0OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLlRZUE9HUkFQSFkuZm9udFdlaWdodC5ib2xkfTtcbiAgJHsoeyB0aGVtZSB9KSA9PiBhcHBseVByaW1hcnlUaGVtZVZlcnRpY2FsT2Zmc2V0KHRoZW1lKX07XG5gO1xuY29uc3QgQ2hpcFN0eWxlcyA9IHN0eWxlZC5kaXYgYFxuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLkJPUkRFUl9SQURJVVMuc21hbGx9O1xuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgaGVpZ2h0OiAke1NQQUNFUi5sYXJnZX07XG4gIGZsZXgtZmxvdzogcm93IG5vd3JhcDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDAgJHtTUEFDRVIuc21hbGx9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IGJhY2tncm91bmRDb2xvciB9KSA9PiBiYWNrZ3JvdW5kQ29sb3J9O1xuXG4gICR7Q2hpcFRleHR9IHtcbiAgICBjb2xvcjogJHsoeyB0ZXh0Q29sb3IgfSkgPT4gdGV4dENvbG9yfTtcbiAgfVxuYDtcbmV4cG9ydCBkZWZhdWx0IHsgQ2hpcFN0eWxlcywgQ2hpcFRleHQgfTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlLmpzLm1hcCJdfQ== */"));

var ChipStyles = _styled("div", {
  target: "e88p7tz0",
  label: "ChipStyles"
})("align-items:center;border-radius:", _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.BORDER_RADIUS.small;
}, ";display:inline-flex;height:", SPACER.large, ";flex-flow:row nowrap;justify-content:center;align-items:center;padding:0 ", SPACER.small, ";background-color:", _ref5 => {
  var {
    backgroundColor
  } = _ref5;
  return backgroundColor;
}, ";", ChipText, "{color:", _ref6 => {
  var {
    textColor
  } = _ref6;
  return textColor;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVM4QiIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRZUE9HUkFQSFlfU1RZTEUgfSBmcm9tICcuLi90eXBvZ3JhcGh5JztcbmltcG9ydCB7IFNQQUNFUiB9IGZyb20gJy4uLy4uL2NvbnN0YW50cyc7XG5pbXBvcnQgeyBhcHBseVByaW1hcnlUaGVtZVZlcnRpY2FsT2Zmc2V0IH0gZnJvbSAnLi4vLi4vdXRpbHMvdGhlbWVTdHlsZXMnO1xuY29uc3QgQ2hpcFRleHQgPSBzdHlsZWQuc3BhbiBgXG4gICR7KHsgdGhlbWUgfSkgPT4gVFlQT0dSQVBIWV9TVFlMRS5sYWJlbCh0aGVtZSl9XG4gIGZvbnQtd2VpZ2h0OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLlRZUE9HUkFQSFkuZm9udFdlaWdodC5ib2xkfTtcbiAgJHsoeyB0aGVtZSB9KSA9PiBhcHBseVByaW1hcnlUaGVtZVZlcnRpY2FsT2Zmc2V0KHRoZW1lKX07XG5gO1xuY29uc3QgQ2hpcFN0eWxlcyA9IHN0eWxlZC5kaXYgYFxuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLkJPUkRFUl9SQURJVVMuc21hbGx9O1xuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgaGVpZ2h0OiAke1NQQUNFUi5sYXJnZX07XG4gIGZsZXgtZmxvdzogcm93IG5vd3JhcDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDAgJHtTUEFDRVIuc21hbGx9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IGJhY2tncm91bmRDb2xvciB9KSA9PiBiYWNrZ3JvdW5kQ29sb3J9O1xuXG4gICR7Q2hpcFRleHR9IHtcbiAgICBjb2xvcjogJHsoeyB0ZXh0Q29sb3IgfSkgPT4gdGV4dENvbG9yfTtcbiAgfVxuYDtcbmV4cG9ydCBkZWZhdWx0IHsgQ2hpcFN0eWxlcywgQ2hpcFRleHQgfTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlLmpzLm1hcCJdfQ== */"));

var Style = {
  ChipStyles,
  ChipText
};

export { Style as default };
